// ProtectedRoute.jsx
import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { checkIsAdmin } from '../api/api';
import Loader from './elements/Loader/Loader';

export default function ProtectedRoute({ children }) {
    const [loading, setLoading] = useState(true);
    const [isAuthorized, setIsAuthorized] = useState(false);

    useEffect(() => {
        const checkAccess = async () => {
            try {
                const key = localStorage.getItem('key') || '';
                
                if (key.trim() === '') {
                    setIsAuthorized(false);
                    setLoading(false);
                    return;
                }

                const result = await checkIsAdmin()

                if (result === true) {
                    setIsAuthorized(true);
                } else {
                    setIsAuthorized(false);
                }
            } catch (error) {
                setIsAuthorized(false);
            } finally {
                setLoading(false);
            }
        };

        checkAccess();
    }, []);

    if (loading) {
        return <Loader />
    }

    if (!isAuthorized) {
        return <Navigate to="/" replace />;
    }

    return children;
}
